export const REDUX_CONSTANTS = {
  AUTH: {
    FEATURE_KEY: "AUTH",
  },
  
  COMMON: {
    FEATURE_KEY: "COMMON",
  },
};
